import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import backgroundImage from '../assets/img/background.jpg';
import useStyles from '../styles/styles';
import { useTranslation } from "react-i18next";
import { FONT_FAMILY } from '../common/sharedFunctions';

const Hero = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  return (
    <Box
      className={classes.heroBox}
      sx={{
        position: 'relative',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        minHeight: '80vh',
      }}
      style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}
    >
      {/* Dark overlay */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(90deg, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0.45) 50%, rgba(0,0,0,0.2) 100%)',
          zIndex: 1,
        }}
      />

      <Grid
        container
        className={classes.gridContainer}
        sx={{
          position: 'relative',
          zIndex: 2,
          minHeight: '70vh',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Grid item xs={12} md={8}>
          <Typography
            variant="h3"
            fontWeight={600}
            sx={{
              color: '#fff',
              fontFamily: FONT_FAMILY,
              mb: 2,
              textShadow: '0 4px 20px rgba(0,0,0,0.6)',
            }}
          >
            {t('book_your_title')}
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: 'rgba(255,255,255,0.9)',
              fontFamily: FONT_FAMILY,
              maxWidth: '700px',
              mx: 'auto',
              textShadow: '0 2px 10px rgba(0,0,0,0.5)',
            }}
          >
            {t('about_us_content2')}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Hero;
